// extracted by mini-css-extract-plugin
export default {"myScrollbarContainer":"CustomScrollbar_myScrollbarContainer__VJMAI","sessionSection":"CustomScrollbar_sessionSection__Urjh2","goalSection":"CustomScrollbar_goalSection__dpXob"};